<style lang="less">
@import "../nav.less";
</style>
<template>
    <div class="menu-items menu-top">
         <!-- 手机端  点击图标显示导航 -->
        <div class="menu-icon" @click="showFixedNav">
          <img src=".././../assets/images/caidan2.png">
        </div>
        <el-menu
          v-show="showNav"
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          router
          @open="handleOpen"
          @close="handleClose">
          
          <el-menu-item index="/index">
            <span slot="title">HOME</span>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">
              <span>ABOUT US</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/aboutUs">ABOUT US</el-menu-item>
              <el-menu-item index="/certification">CERTIFICATION</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <span>PRODUCTS</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/fabric">FABRIC</el-menu-item>
              <el-menu-item index="/garment">GARMENT</el-menu-item>
              <el-menu-item index="/schoolUniform">SCHOOL UNIFORM</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/customMade">
            <span slot="title">CUSTOM MADE</span>
          </el-menu-item>
          <el-menu-item index="/qualityControl">
            <span slot="title">QUALITY CONTROL</span>
          </el-menu-item>
          <el-menu-item index="/contact">
            <span slot="title">CONTACT US</span>
          </el-menu-item>
        </el-menu>

        <img class="title-img" src="../../assets/images/LAKETAIApparel.jpg">
        <el-menu :default-active="activeIndex" class="el-menu-demo no-menu-icon" mode="horizontal" router @open="handleOpen" @select="handleSelect">
            <el-menu-item index="/index">HOME</el-menu-item>
            <el-submenu index="2">
            <template slot="title">ABOUT US</template>
            <el-menu-item index="/aboutUs">ABOUT US</el-menu-item>
            <el-menu-item index="/certification">CERTIFICATION</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
            <template slot="title">PRODUCTS</template>
            <el-menu-item index="/fabric">FABRIC</el-menu-item>
            <el-menu-item index="/garment">GARMENT</el-menu-item>
            <el-menu-item index="/schoolUniform">SCHOOL UNIFORM</el-menu-item>
            </el-submenu>
            <el-menu-item index="/customMade">CUSTOM MADE</el-menu-item>
            <el-menu-item index="/qualityControl">QUALITY CONTROL</el-menu-item>
            <el-menu-item index="/contact">CONTACT US</el-menu-item>
        </el-menu>

       
    </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: '1',
      showNav: false
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(){},
    showFixedNav(){
      this.showNav = !this.showNav
    }
  },
  watch: {},
  mounted () {
  }
}
</script>
